import { useMemo } from 'react'
import { Dropdown } from 'components/common'
import AggregatorDropdown from 'components/common/aggregatorDropdown'
import StoreDropdown from 'components/userManagement/storeDropdown'
import {
  FilterDateInput,
  FilterTextInput,
} from 'components/common/logFilterInputs'
import useLogFilters from 'hooks/useLogFilters'
import { buildEnumOptions, FilterMeta } from 'utils/helpers'

type Props = {
  filterMeta?: FilterMeta
}

export const FILTER_FIELD_LAST_MILE_LOG = 'lastMileLogFilters'

const HAS_ERROR_OPTIONS = [
  { label: '--- NONE ---', value: 'NONE' },
  { label: 'Yes', value: 'true' },
  { label: 'No', value: 'false' },
]

const LastMileLogFilterForm = ({ filterMeta }: Props) => {
  const { filters, setField } = useLogFilters(FILTER_FIELD_LAST_MILE_LOG)

  const lastMileTypeOptions = useMemo(
    () => buildEnumOptions(filterMeta, 'lastMileType', ['INSTASHOP']),
    [filterMeta],
  )

  const statusOptions = useMemo(
    () => buildEnumOptions(filterMeta, 'status', ['SUCCESS', 'FAILED']),
    [filterMeta],
  )

  const eventTypeOptions = useMemo(
    () => buildEnumOptions(filterMeta, 'eventType', []),
    [filterMeta],
  )

  return (
    <div className="mb-6 flex flex-wrap items-end gap-4 rounded-xl border border-gray-200 bg-white px-5 py-4 shadow-sm">
      <div className="min-w-[200px]">
        <Dropdown
          name="lastMileType"
          label="Last Mile"
          options={lastMileTypeOptions}
          defaultValue={filters.lastMileType || ''}
          setValue={(_field: string, value: string) =>
            setField('lastMileType', value)
          }
        />
      </div>

      <div className="min-w-[200px]">
        <Dropdown
          name="status"
          label="Status"
          options={statusOptions}
          defaultValue={filters.status || ''}
          setValue={(_field: string, value: string) =>
            setField('status', value)
          }
        />
      </div>

      <div className="min-w-[220px]">
        <Dropdown
          name="eventType"
          label="Event Type"
          options={eventTypeOptions}
          defaultValue={filters.eventType || ''}
          setValue={(_field: string, value: string) =>
            setField('eventType', value)
          }
        />
      </div>

      <FilterTextInput
        label="Order No"
        value={filters.orderNo || ''}
        onApply={(value) => setField('orderNo', value)}
      />

      <div className="min-w-[200px]">
        <AggregatorDropdown
          withNoneOption
          name="aggregator"
          label="Aggregator"
          defaultValue={filters.aggregator || ''}
          setValue={(_field: string, value: string) =>
            setField('aggregator', value)
          }
        />
      </div>

      <div className="min-w-[200px]">
        <StoreDropdown
          withNoneOption
          name="store"
          label="Store"
          defaultValue={filters.store || ''}
          setValue={(_field: string, value: string) => setField('store', value)}
        />
      </div>

      <div className="min-w-[160px]">
        <Dropdown
          name="hasError"
          label="Has Error"
          options={HAS_ERROR_OPTIONS}
          defaultValue={filters.hasError || ''}
          setValue={(_field: string, value: string) =>
            setField('hasError', value)
          }
        />
      </div>

      <FilterDateInput
        label="Start Date"
        value={filters.startDate || ''}
        onChange={(value) => setField('startDate', value)}
      />

      <FilterDateInput
        label="End Date"
        value={filters.endDate || ''}
        onChange={(value) => setField('endDate', value)}
      />
    </div>
  )
}

export default LastMileLogFilterForm
